import { Icon } from '@/new/components/icon';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/new/components/shadcn/tooltip';

export const CloseIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className="absolute top-2 right-2 z-30 flex cursor-pointer items-center rounded-lg border border-gray-200 bg-white px-1.5 py-1 text-sm shadow-lg"
            onClick={onClick}
          >
            <Icon className="lucide--x hover:scale-110 hover:text-gray-600" />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Close viewer</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
